import { APICONSTANTS } from '../../constants/api-constants';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CondReglModel } from '../../models/simple-types/cond-regl.model';
import { HostnameService } from '../basic/hostname.service';
import { GenericLibelleService } from '../basic/generic-libelle.service';

@Injectable()
export class CondReglService extends GenericLibelleService<CondReglModel> {
    constructor(http: HttpClient,
                protected toastrService: ToastrService,
                protected hostnameService: HostnameService) {
        super(http, toastrService, APICONSTANTS.ROUTECONDREGL, hostnameService);
  }
}
